import { config } from '@/plugins/login';

console.log(config);

import Vue from 'vue';

import App from '@/App.vue';

import { createRouter } from '@/router';
import store from '@/vuex';
import { i18n } from '@/language';

import '@/components/icons/globalIcons';
import '@/components/base/globalBases';

Vue.config.productionTip = false;

new Vue({
  router: createRouter(config.subdomain),
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
